<div class="settlement-dialog p-4 sm:p-6 font-display bg-white">
  <div class="dialog-header">
    <div class="min-w-0">
      <h2 class="dialog-header__title">{{ getDialogTitle() }}</h2>
      <p class="dialog-header__subtitle">
        {{ data.cashAdvance?.title }} · #{{ data.cashAdvance?.refId }}
      </p>
    </div>
    <button type="button" (click)="cancel()" class="dialog-close" aria-label="Tutup">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <ng-container *ngIf="isDetailView; else settlementForm">
    <div class="info-grid">
      <div class="info-field">
        <span class="info-field__label">Amount</span>
        <span class="info-field__value">{{ getFormattedAmount() }}</span>
      </div>

      <div class="info-field">
        <span class="info-field__label">Settlement date</span>
        <span class="info-field__value">{{ getFormattedDate() }}</span>
      </div>

      <div class="info-field info-field--full">
        <span class="info-field__label">Tag</span>
        <span class="info-field__value">{{ getTagName() }}</span>
      </div>

      <div class="info-field info-field--full">
        <span class="info-field__label">Description</span>
        <div class="info-field__text-block">
          {{ form.get('desciption')?.value || '-' }}
        </div>
      </div>

      <div class="info-field">
        <span class="info-field__label">Location</span>
        <span class="info-field__value">{{ form.get('location')?.value || '-' }}</span>
      </div>

      <div class="info-field">
        <span class="info-field__label">Notes</span>
        <span class="info-field__value">{{ form.get('notes')?.value || '-' }}</span>
      </div>

      <div class="info-field info-field--full">
        <span class="info-field__label">Lampiran</span>
        <button
          type="button"
          class="attachment-item w-full text-left"
          *ngIf="getPrimaryFile(); else noAttachment"
          (click)="download()"
          [disabled]="isDownloading"
        >
          <span class="attachment-item__name">
            <i
              class="fa-solid shrink-0 text-red-500"
              [ngClass]="getFileIconClass()"
            ></i>
            <span class="truncate">{{ getDisplayFileName() }}</span>
          </span>
          <span class="attachment-item__action">
            <span
              class="attachment-item__size"
              *ngIf="getPrimaryFile()?.fileSize"
              >{{ formatFileSize(getPrimaryFile()?.fileSize) }}</span
            >
            <i class="fa-solid fa-eye text-slate-400"></i>
          </span>
        </button>
        <ng-template #noAttachment>
          <span class="empty-text">Tidak ada lampiran</span>
        </ng-template>
      </div>
    </div>

    <div class="dialog-footer">
      <button type="button" (click)="cancel()" class="btn btn--secondary">
        Tutup
      </button>
    </div>
  </ng-container>

  <ng-template #settlementForm>
  <form [formGroup]="form">
    <div class="form-grid">
      <!-- Form fields -->
      <div class="form-fields">
        <div class="field-row">
          <div class="field">
            <label class="field__label" for="settlement-amount">Amount</label>
            <input
              id="settlement-amount"
              formatNumber
              formatCurrency
              type="text"
              formControlName="amount"
              class="field__input"
              [ngClass]="{ 'field__input--error': hasFieldError('amount') }"
              placeholder="Masukkan nominal"
            />
            <span *ngIf="hasFieldError('amount')" class="field__error"
              >Amount wajib diisi</span
            >
          </div>

          <div class="field">
            <label class="field__label">Currency</label>
            <mat-select
              formControlName="currency"
              class="field-select w-full"
              [ngClass]="{ 'field-select--error': hasFieldError('currency') }"
              placeholder="Pilih currency"
            >
              <mat-option value="Rp">Rupiah</mat-option>
              <mat-option value="USD">US Dollar</mat-option>
              <mat-option value="SGD">Singapore Dollar</mat-option>
            </mat-select>
            <span *ngIf="hasFieldError('currency')" class="field__error"
              >Currency wajib diisi</span
            >
          </div>
        </div>

        <div class="field-row">
          <div class="field">
            <label class="field__label" for="settlement-date">Settlement date</label>
            <input
              id="settlement-date"
              type="date"
              formControlName="settlementDate"
              class="field__input"
              [ngClass]="{ 'field__input--error': hasFieldError('settlementDate') }"
             placeholder="Pilih tanggal settlement"/>
            <span *ngIf="hasFieldError('settlementDate')" class="field__error"
              >Tanggal wajib diisi</span
            >
          </div>

          <div class="field">
            <label class="field__label">Tag</label>
            <mat-select
              formControlName="tagId"
              class="field-select w-full"
              [ngClass]="{ 'field-select--error': hasFieldError('tagId') }"
              placeholder="Pilih tag"
            >
              <mat-option *ngFor="let item of tag" [value]="item.id">{{
                item.name
              }}</mat-option>
            </mat-select>
            <span *ngIf="hasFieldError('tagId')" class="field__error"
              >Tag wajib diisi</span
            >
          </div>
        </div>

        <div class="field field--full">
          <label class="field__label" for="settlement-description">Description</label>
          <textarea
            id="settlement-description"
            formControlName="desciption"
            class="field__textarea"
            [ngClass]="{ 'field__input--error': hasFieldError('desciption') }"
            placeholder="Masukkan deskripsi"
          ></textarea>
          <span *ngIf="hasFieldError('desciption')" class="field__error"
            >Description wajib diisi</span
          >
        </div>

        <div class="field field--full">
          <label class="field__label" for="settlement-location">Location</label>
          <input
            id="settlement-location"
            type="text"
            formControlName="location"
            class="field__input"
            [ngClass]="{ 'field__input--error': hasFieldError('location') }"
            placeholder="Masukkan lokasi"
          />
          <span *ngIf="hasFieldError('location')" class="field__error"
            >Location wajib diisi</span
          >
        </div>

        <div class="field field--full">
          <label class="field__label" for="settlement-notes">Notes</label>
          <textarea
            id="settlement-notes"
            formControlName="notes"
            class="field__textarea"
            [ngClass]="{ 'field__input--error': hasFieldError('notes') }"
            placeholder="Masukkan catatan"
          ></textarea>
          <span *ngIf="hasFieldError('notes')" class="field__error"
            >Notes wajib diisi</span
          >
        </div>
      </div>

      <!-- Attachment -->
      <div class="attachment-panel">
        <span class="field__label">Lampiran</span>

        <input
          type="file"
          #fileInput
          name="file"
          class="hidden"
          multiple
          (change)="uploadFile($event)"
        />

        <div
          class="attachment-dropzone"
          [ngClass]="{ 'attachment-dropzone--has-file': fileExists }"
          (click)="fileInput.click()"
        >
          <mat-spinner [diameter]="36" *ngIf="uploadStatus"></mat-spinner>
          <ng-container *ngIf="!uploadStatus">
            <i
              class="fa-solid fa-file attachment-dropzone__icon"
              [ngClass]="fileExists ? 'text-red-500' : 'text-slate-300'"
            ></i>
            <span class="attachment-dropzone__name" *ngIf="fileExists">{{
              fileName
            }}</span>
            <span class="attachment-dropzone__hint" *ngIf="!fileExists">
              Klik untuk upload file<br />
              jpg, png, pdf, xls, doc
            </span>
          </ng-container>
        </div>

        <div class="attachment-actions" *ngIf="fileExists">
          <button
            type="button"
            class="attachment-btn"
            (click)="fileInput.click()"
          >
            <i class="fa-solid fa-plus text-xs"></i>
            Tambah file
          </button>
          <button type="button" class="attachment-btn" (click)="download()">
            <i class="fa-solid fa-eye text-xs"></i>
            Lihat file
          </button>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <button type="button" (click)="cancel()" class="btn btn--secondary">
        Batal
      </button>
      <button
        type="button"
        (click)="submit()"
        class="btn btn--primary"
        [disabled]="form.invalid"
      >
        Simpan
      </button>
    </div>
  </form>
  </ng-template>
</div>
